import React from "react";
import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import Istimara from "./img/est.png";
const MyDocument = ({
  fn1,
  fn2,
  fn3,

  univ,
  depar,
  level,
  title,
  phone,
  desc,
  email,
}) => (
  <Document>
    <Page
      size="A4"
      style={{ width: "100%", height: "100%", position: "relative" }}
    >
      <Image src={Istimara} />
    </Page>

    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "120px",
        left: "73px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>
        {new Date().getDate()}/{new Date().getMonth() + 1}/
        {new Date().getFullYear()}
      </Text>
    </View>
    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "170px",
        left: "100px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{fn1}</Text>
    </View>

    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "195px",
        left: "100px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{fn2}</Text>
    </View>

    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "220px",
        left: "100px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{fn3}</Text>
    </View>

    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "245px",
        left: "110px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{univ}</Text>
    </View>
    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "273px",
        left: "120px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{depar}</Text>
    </View>
    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "300px",
        left: "100px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{level}</Text>
    </View>
    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "400px",
        left: "80px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{title}</Text>
    </View>
    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "449px",
        left: "20px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>
        {desc.slice(0, 80)}...
      </Text>
    </View>
    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "343px",
        left: "98px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{phone}</Text>
    </View>
    <View
      style={{
        position: "absolute",
        zIndex: "200",
        top: "320px",
        left: "70px",
      }}
    >
      <Text style={{ fontWeight: "bold", fontSize: "15px" }}>{email}</Text>
    </View>
  </Document>
);

export default MyDocument;
